
















import Vue from 'vue'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { presetDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { Preset } from '@/types/api'
import { checkNameDuplicated } from '@/utils'

export default mixins(presetDialogMixin).extend({
  data () {
    return {
      newName: '',
      newNote: '',
    }
  },
  computed: {
    device (): Preset | null { return this.dialog.preset },
    nameDuplicated (): boolean {
      if (!this.dialog.preset) {return true}
      return checkNameDuplicated(this.newName, this.dialog.preset.name, this.$state.device.presetList)
    }
  },
  methods: {
    async apply () {
      if (!this.dialog.preset) { console.error('[To Developer] this should not happen'); return }
      const ok = await easyapi.renamePreset(this.dialog.preset.id, this.newName, this.newNote)
      if (ok) {
        this.$emit('presetRename')
        this.closeThisDialog()
      }
    }
  },
  watch: {
    'dialog.preset' (nv: Preset | null) {
      if (nv) {
        this.newName = nv.name
        this.newNote = nv.note
      }
    }
  }
})
